(function () {
  var SECTION_SELECTOR = '[data-cd-dentist-testimonials]';

  function initSection(section) {
    if (!section || section.dataset.cdDentistTestimonialsReady === 'true') return;

    var viewport = section.querySelector('[data-cd-testimonials-viewport]');
    var track = section.querySelector('[data-cd-testimonials-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-cd-testimonial]'));
    var pages = Array.prototype.slice.call(section.querySelectorAll('[data-cd-testimonial-page]'));
    var activeIndex = 0;
    var scrollFrame = null;
    var scrollStops = [];

    if (!viewport || !cards.length) return;
    section.dataset.cdDentistTestimonialsReady = 'true';

    function buildScrollStops() {
      var trackPadding = track ? parseFloat(window.getComputedStyle(track).paddingLeft) || 0 : 0;
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var nextStops = [];

      cards.forEach(function (card, cardIndex) {
        var left = Math.max(0, Math.min(card.offsetLeft - trackPadding, maxScroll));
        var previous = nextStops[nextStops.length - 1];

        if (previous && Math.abs(previous.left - left) < 2) {
          previous.cardIndex = cardIndex;
          return;
        }

        nextStops.push({ left: left, cardIndex: cardIndex });
      });

      scrollStops = nextStops;

      pages.forEach(function (page, pageIndex) {
        var stop = scrollStops[pageIndex];
        page.hidden = !stop;
        if (!stop) {
          page.removeAttribute('aria-current');
          return;
        }

        page.setAttribute('aria-label', 'Show testimonial ' + (stop.cardIndex + 1));
      });
    }

    function nearestIndex() {
      var nearest = 0;
      var shortestDistance = Infinity;

      scrollStops.forEach(function (stop, index) {
        var distance = Math.abs(viewport.scrollLeft - stop.left);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearest = index;
        }
      });

      return nearest;
    }

    function setActive(index) {
      var lastIndex = Math.max(0, scrollStops.length - 1);
      var nextIndex = Math.max(0, Math.min(index, lastIndex));
      activeIndex = nextIndex;
      pages.forEach(function (page, pageIndex) {
        var isActive = !page.hidden && pageIndex === activeIndex;
        page.classList.toggle('is-active', isActive);
        page.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var targetIndex = Math.max(0, Math.min(index, scrollStops.length - 1));
      var target = scrollStops[targetIndex];
      if (!target) return;

      setActive(targetIndex);
      viewport.scrollTo({
        left: target.left,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    viewport.addEventListener('scroll', function () {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        setActive(nearestIndex());
      });
    }, { passive: true });

    pages.forEach(function (page, pageIndex) {
      page.addEventListener('click', function () {
        goTo(pageIndex);
      });
    });

    window.addEventListener('resize', function () {
      buildScrollStops();
      setActive(nearestIndex());
    }, { passive: true });

    buildScrollStops();
    setActive(nearestIndex());
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

})();
